import React, { useCallback, useEffect, useState } from 'react';
import Accordion from '../../components/common/Accordian';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianPlusIcon from '../../assets/AccordianPlusIcon';
import AccordianMinusIcon from '../../assets/AccordianMinusIcon';
import ViewBookingDetailsCard from '../../components/common/ViewBookingDetails';
import {
  encodeDateForUrl,
  getAdjustedDate,
  validateDateRange,
} from '../../utils/dateUtils';
import viewBookingAPI from '../../api/viewBookingAPI';
import { DateSelector } from '../../components';
import useUserStore from '../../store/userStore';
import useLocationStore from '../../store/locatonStore';
import { generatePretravelLink } from '../../utils/generatePretravelLink';
import { translate } from '../../i18n';
import Loader from '../../assets/loader/Loader';
import { locationConstant } from '../../constants/constant';
import useBgColorStore from '../../store/bgColor';
import CalendarHeader from '../../components/common/Header/CalenderHeader';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import AccordianPlusIconDark from '../../assets/icon/AccordianPlusIconDark';
import AccordianMinusIconDark from '../../assets/icon/AccordianMinusIconDark';

const BookingsMobile = () => {
  const user = useUserStore((state) => state.user);
  const { bgColor, updateBgColor } = useBgColorStore();
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const [selectedToDate, setSelectedToDate] = useState<Date>(getAdjustedDate());
  const [selectedFromDate, setSelectedFromDate] =
    useState<Date>(getAdjustedDate());
  const [viewBooking, setViewBooking] = useState<any>([]);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const bookingsManifest = useCallback(
    async (
      toDate: Date,
      fromDate: Date,
      contactStaffId: number | null | undefined,
      ownerId: number,
    ) => {
      try {
        const encodedToDate = encodeDateForUrl(toDate);
        const encodedFromDate = encodeDateForUrl(fromDate);
        console.log('contact staff Id', contactStaffId);
        setIsPageLoading(true);
        const response = await viewBookingAPI.getBookingManifest(
          ownerId,
          contactStaffId,
          encodedToDate,
          encodedFromDate,
        );
        console.log(response?.data);
        setViewBooking(response?.data?.bookingsManifest);
      } catch (error) {
      } finally {
        setIsPageLoading(false);
      }
    },
    [],
  );

  useEffect(() => {
    bookingsManifest(
      selectedToDate,
      selectedFromDate,
      user?.id,
      selectedLocation.OwnerId,
    );
  }, [
    selectedToDate,
    selectedFromDate,
    bookingsManifest,
    user,
    selectedLocation,
  ]);

  const handleFromDateChange = (date: Date | null) => {
    if (date) {
      setSelectedFromDate(date);
      if (validateDateRange(date, selectedToDate)) {
        setSelectedToDate(date);
      }
    }
  };
  const handleToDateChange = (date: Date | null) => {
    if (date) {
      setSelectedToDate(date); // Update the selected date
    }
  };

  return (
    <div className={`w-full bg-background h-max `}>
      <div className="mt-2 bg-backgroundColor-white">
        <CalendarHeader />
      </div>
      <div className="flex items-start pl-4 pr-4 pt-4">
        <span className="font-semibold text-base text-textColor">
          {translate('viewBookings.viewBooking')}
        </span>
      </div>
      <div className="flex justify-between items-center gap-4 pl-4 pr-4 pt-4 rounded">
        {/* From section */}
        <div className="flex flex-col w-1/2">
          <label className="text-sm text-start mb-1 text-textColorGray">
            {translate('common.from')}
          </label>
          <div
            className={`${bgColor} flex items-center space-x-1 h-[44px] p-2 rounded`}
          >
            <DateSelector
              onDateChange={handleFromDateChange}
              initialDate={selectedFromDate}
              showArrows={false}
            />
          </div>
        </div>

        {/* To section */}
        <div className="flex flex-col w-1/2">
          <label className="text-sm text-start mb-1 text-textColorGray">
            {translate('common.to')}
          </label>
          <div
            className={`${bgColor} flex items-center space-x-1 h-[44px] p-2 rounded`}
          >
            <DateSelector
              onDateChange={handleToDateChange}
              initialDate={selectedToDate}
              showArrows={false}
            />
          </div>
        </div>
      </div>
      <div className={`${bgColor}`}>
        <div
          className={`mt-4 py-4 ${viewBooking?.length === 0 ? 'h-screen' : ''}`}
        >
          {isPageLoading ? (
            <div className="inline-grid">
              <Loader width={50} height={50} />
            </div>
          ) : viewBooking?.length === 0 ? (
            <div className="text-text-primary flex justify-center items-center h-80 text-lg font-medium">
              {translate('flightAllocation.noData')}
            </div>
          ) : (
            viewBooking?.map((bookingManifest: any) => (
              <div
                key={bookingManifest?.date}
                className="border-b-8 border-background pb-4 mb-4"
              >
                <Accordion
                  title={`${bookingManifest?.date}`}
                  bgColor={`${bgColor}`}
                  iconOpen={
                    <div>
                      <div className="block dark:hidden">
                        <AccordianDownIcon />
                      </div>
                      <div className="hidden dark:block">
                        <AccordianDownIconDark />
                      </div>
                    </div>
                  }
                  iconClose={
                    <div>
                      <div className="block dark:hidden">
                        <AccordianUpIcon />
                      </div>
                      <div className="hidden dark:block">
                        <AccordianUpIconDark />
                      </div>
                    </div>
                  }
                  key={bookingManifest?.date}
                >
                  <div className="">
                    {/* Pretravel Section */}
                    <div className="flex flex-row items-center gap-2 mb-4">
                      <h2 className="font-medium text-textColorGray mb-2 mr-auto">
                        {translate('viewBookings.Pretravel')}
                      </h2>
                      <div className="grid grid-cols-3 gap-3 w-[70%]">
                        <div className="bg-backgroundColor-white rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.passed')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.preTravel?.['Passed'] || 0}
                          </span>
                        </div>
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.sent')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.preTravel?.['Sent'] || 0}
                          </span>
                        </div>
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.notSent')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.preTravel?.['Not Sent'] || 0}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Status Section */}
                    <div className="flex flex-row gap-2 mb-4">
                      <h2 className="font-medium text-start text-textColorGray mb-2 mr-auto">
                        {translate('viewBookings.status')}
                      </h2>
                      <div className="grid grid-cols-3 gap-3 w-[70%]">
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.booked')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.statusCounts?.['Booked'] || 0}
                          </span>
                        </div>
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.confirmed')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.statusCounts?.['Confir'] || 0}
                          </span>
                        </div>
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.rebook')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.statusCounts?.['Not Sent'] || 0}
                          </span>
                        </div>
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.paid')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.statusCounts?.['Not Sent'] || 0}
                          </span>
                        </div>
                        <div className="bg-backgroundColor-white  rounded-lg p-2 flex flex-col items-center">
                          <span className="text-textColorGray text-sm">
                            {translate('viewBookings.voucher')}
                          </span>
                          <span className="text-textColor text-lg font-semibold">
                            {bookingManifest?.statusCounts?.['Not Sent'] || 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {bookingManifest?.bookings?.map(
                    (booking: any, index: number) => (
                      <Accordion
                        title={`${booking.bookingDetails?.[0]?.bookingName} : ${booking.bookingDetails?.[0]?.male}/${booking.bookingDetails?.[0]?.female}/${booking.bookingDetails?.[0]?.children}:${booking.bookingDetails?.[0]?.paxNo}`}
                        bgColor="bg-backgroundColor-white"
                        iconOpen={
                          <div>
                            <div className="block dark:hidden">
                              <AccordianPlusIcon />
                            </div>
                            <div className="hidden dark:block">
                              <AccordianPlusIconDark />
                            </div>
                          </div>
                        }
                        iconClose={
                          <div>
                            <div className="block dark:hidden">
                              <AccordianMinusIcon />
                            </div>
                            <div className="hidden dark:block">
                              <AccordianMinusIconDark />
                            </div>
                          </div>
                        }
                        status={booking.bookingDetails?.[0]?.status}
                        key={index}
                      >
                        <div>
                          {/* 👇 Pass the whole array of booking details */}
                          <ViewBookingDetailsCard
                            bookings={booking.bookingDetails}
                          />
                        </div>
                      </Accordion>
                    ),
                  )}
                </Accordion>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingsMobile;
